/**
 * Created by pandemio on 4/12/19.
 */
import React from 'react';
import {Card, Col, Container, Row} from 'reactstrap';

/** Multiple Language imports **/
import {withLocalize} from "react-localize-redux";
import {renderToStaticMarkup} from 'react-dom/server'; // Fix by the author. Do not remove even if it's not resolved
import {Translate} from "react-localize-redux";
import global from "../../translations/global.json"
/** End of Multiple Language imports **/
import LanguageManager from '../../custom-classes/language-manager';
import NavbarDesktop from './navbar-employee/navbar-desktop';
import NavbarMobile from './navbar-employee/navbar-mobile';
import Footer from '../footer/footer';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faUsers} from '@fortawesome/free-solid-svg-icons';
import UsersDataTable from '../datatables/users-data-table';
import Settings from '../../custom-classes/settings';

/**
 * A simple report to read the clients
 */
class ReportClients extends React.Component {

    constructor(props) {
        // Super is always called when defining the constructor of a subclass
        // All React component classes that have a constructor, should start it with a super(props) call.
        super(props);
        let languages = [
            {name: "English", code: "en"},
            {name: "Español", code: "es"}
        ];

        // To support language library add the following lines
        this.props.initialize({
            languages,
            options: {renderToStaticMarkup, defaultLanguage: LanguageManager.getLanguage()}
        });

        this.state = {
            languages: languages,
            planName: '',
            fromDate: null,
            toDate: null,
            planId: null
        };
        this.props.addTranslation(global);

        this.handleClientSelected = this.handleClientSelected.bind(this);
    }

    /** Evaluate the resize, to show the proper navbar menu style*/
    componentDidMount() {
        window.addEventListener("resize", this.resize.bind(this));
        this.resize();

    }

    resize() {
        this.setState({navbarMobile: window.screen.width <= 1024});
    }

    handleClientSelected(e){

    }

    /**
     * Renders the main dashboard
     * @returns {XML}
     */
    render() {
        return (
            <div>
                {this.state.navbarMobile ? <NavbarMobile/> : <NavbarDesktop/>}
                <div className="container-padding">
                    <Container className={this.state.navbarMobile ? "margin-top-mandatory-60" : null}>
                        <h2 className="font-now-bold white-text">
                            <FontAwesomeIcon icon={faUsers}/>{' '}
                            <Translate id="reports.clients" options={{renderInnerHtml: true}}/>
                        </h2>
                        <small className="white-text">
                            <Translate id="reports.clients-instructions" options={{renderInnerHtml: true}}/>
                        </small>
                        <hr/>
                        <Row>
                            <Col lg={{size: 12}} md={{size: 12}} sm={{size: 12}} xs={{size: 12}}>
                                <Card body className="card-blue-transparency">
                                    <Row>
                                        <Col lg={{size: 12}} md={{size: 12}} sm={{size: 12}} xs={{size: 12}}>
                                            <h5><Translate id="reports.filter" options={{renderInnerHtml: false}}/></h5>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col lg={{size: 12}} md={{size: 12}} sm={{size: 12}} xs={{size: 12}}>
                                            <UsersDataTable roleId={Settings.CLIENT_ROLE_ID} updateParent={this.handleClientSelected}/>
                                        </Col>
                                    </Row>
                                </Card>
                            </Col>
                        </Row>

                    </Container>
                </div>
                <Footer/>
            </div>

        )
    };
}

export default withLocalize(ReportClients);